interface EmailPreviewProps {
  htmlContent: string;
  onClose: () => void;
}

/**
 * Composant de prévisualisation d'email HTML
 * Affiche le rendu HTML dans un iframe (non-éditable)
 */
export function EmailPreview({ htmlContent, onClose }: EmailPreviewProps) {
  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/60 z-50"
        onClick={onClose}
      />

      {/* Modal de prévisualisation */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900">
              📧 Prévisualisation de l'email
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl font-light leading-none"
            >
              ×
            </button>
          </div>

          {/* Contenu (iframe) */}
          <div className="flex-1 overflow-auto p-4 bg-gray-50">
            <iframe
              srcDoc={htmlContent}
              title="Email Preview"
              className="w-full h-full min-h-[600px] bg-white rounded border border-gray-300"
              sandbox="allow-same-origin"
            />
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200 bg-gray-50">
            <button
              onClick={onClose}
              className="w-full px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium"
            >
              Fermer la prévisualisation
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
